"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _utilityClassNames = require("@emcm-ui/utility-class-names");

var _utilityClassNames2 = _interopRequireDefault(_utilityClassNames);

var _reactFromMarkup = require("react-from-markup");

var _componentAlert = require("@emcm-ui/component-alert");

var _componentAlert2 = _interopRequireDefault(_componentAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var fetchContent = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(location) {
    var fetchResponse;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(location, {
              credentials: "same-origin"
            });

          case 2:
            fetchResponse = _context.sent;

            if (fetchResponse.ok) {
              _context.next = 5;
              break;
            }

            throw new Error("Fetch failed for location: " + location);

          case 5:
            return _context.abrupt("return", fetchResponse.text());

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function fetchContent(_x) {
    return _ref.apply(this, arguments);
  };
}();

var AjaxContent = function (_Component) {
  _inherits(AjaxContent, _Component);

  function AjaxContent() {
    var _ref2,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, AjaxContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = AjaxContent.__proto__ || Object.getPrototypeOf(AjaxContent)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      currentLocation: null,
      loadingState: AjaxContent.conditions.UNLOADED,
      retrievedChildren: null
    }, _this.getClassName = (0, _utilityClassNames2.default)(AjaxContent.displayName), _this.loadContent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$props, location, onChange, reactFromMarkupOptions, reactFromMarkupRehydrators, content, domNode, retrievedChildren;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, location = _this$props.location, onChange = _this$props.onChange, reactFromMarkupOptions = _this$props.reactFromMarkupOptions, reactFromMarkupRehydrators = _this$props.reactFromMarkupRehydrators;

              if (!(_this.state.loadingState !== AjaxContent.conditions.LOADING || _this.beganLoading)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:

              _this.beganLoading = true;
              _context2.prev = 4;
              _context2.next = 7;
              return fetchContent(location);

            case 7:
              content = _context2.sent;
              domNode = document.createElement("div");


              domNode.innerHTML = content;

              // if component is not mounted after fetch, abort

              if (_this.componentIsMounted) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return");

            case 12:
              _context2.next = 14;
              return (0, _reactFromMarkup.rehydrateChildren)(domNode, reactFromMarkupRehydrators, reactFromMarkupOptions);

            case 14:
              retrievedChildren = _context2.sent;


              _this.setState({
                retrievedChildren: retrievedChildren,
                currentLocation: location,
                loadingState: AjaxContent.conditions.LOADED
              });
              _context2.next = 22;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](4);

              // eslint-disable-next-line no-console
              console.error("Failed to fetch content", _context2.t0);

              _this.setState({
                retrievedChildren: null,
                currentLocation: null,
                loadingState: AjaxContent.conditions.FAILED
              });

            case 22:
              _this.beganLoading = false;

              if (onChange) {
                onChange(_this.state.loadingState);
              }

            case 24:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[4, 18]]);
    })), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AjaxContent, [{
    key: "componentDidMount",
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.componentIsMounted = true;

                _context3.next = 3;
                return this.loadContent();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _ref4.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.loadContent();

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidUpdate() {
        return _ref5.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.componentIsMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _state = this.state,
          loadingState = _state.loadingState,
          retrievedChildren = _state.retrievedChildren;
      var _props = this.props,
          children = _props.children,
          failedContent = _props.failedContent,
          loadingLabel = _props.loadingLabel,
          minHeight = _props.minHeight;

      var showContent = loadingState !== AjaxContent.conditions.FAILED;
      var showLoader = loadingState === AjaxContent.conditions.LOADING;
      var contentClassName = this.getClassName({ descendantName: "content" });

      var baseFontSize = 16;

      return _react2.default.createElement(
        "div",
        {
          className: this.getClassName(),
          style: minHeight ? { minHeight: minHeight / baseFontSize + "rem" } : null
        },
        showLoader && _react2.default.createElement(
          "div",
          {
            className: this.getClassName({
              descendantName: "loader"
            })
          },
          _react2.default.createElement(
            "div",
            {
              className: this.getClassName({
                descendantName: "loaderLabel",
                utilities: "hiddenVisually"
              })
            },
            loadingLabel
          )
        ),
        showContent && retrievedChildren && _react2.default.createElement(
          "div",
          { className: contentClassName },
          retrievedChildren
        ),
        showContent && !retrievedChildren && _react2.default.createElement(
          "div",
          { className: contentClassName },
          children
        ),
        failedContent && loadingState === AjaxContent.conditions.FAILED && _react2.default.createElement(
          "div",
          {
            className: this.getClassName({
              descendantName: "failed"
            })
          },
          _react2.default.createElement(
            _componentAlert2.default,
            { state: "failure" },
            failedContent
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      // if we have no content to load, we are done
      if (!nextProps.location && state.retrievedChildren) {
        return {
          currentLocation: null,
          loadingState: AjaxContent.conditions.LOADED,
          retrievedChildren: null
        };
      }

      // if location changes, kick off loading
      if (nextProps.location !== state.currentLocation) {
        return {
          loadingState: AjaxContent.conditions.LOADING
        };
      }

      return null;
    }
  }]);

  return AjaxContent;
}(_react.Component);

AjaxContent.displayName = "AjaxContent";
AjaxContent.propTypes = {
  /**
   * children: default content to display.
   */
  children: _propTypes2.default.node,

  /**
   * failed content: content to display when in failed state.
   */
  failedContent: _propTypes2.default.node.isRequired,

  /**
   * loading label: spinning loader label when in loading state.
   */
  loadingLabel: _propTypes2.default.string.isRequired,

  /**
   * content location: path or URL to the content to fetch, rehydrate and
   * display.
   */
  location: _propTypes2.default.string,

  /**
   * Override default minimum height of the content by a number in pixels
   */
  minHeight: _propTypes2.default.number,

  /**
   * Add an onChange callback. Called on loading new content
   */
  onChange: _propTypes2.default.func,

  /**
   * Rehydration options
   */
  reactFromMarkupOptions: _propTypes2.default.object,

  /**
   * A list of rehydrators that are available. Used to rehydrate markup from
   * the server.
   */
  reactFromMarkupRehydrators: _propTypes2.default.object
};
AjaxContent.defaultProps = {
  reactFromMarkupRehydrators: {},
  reactFromMarkupOptions: {}
};
AjaxContent.conditions = {
  UNLOADED: "unloaded",
  LOADING: "loading",
  LOADED: "loaded",
  FAILED: "failed"
};
exports.default = AjaxContent;